import { render, staticRenderFns } from "./car-choose.vue?vue&type=template&id=1c95712b&scoped=true&"
import script from "./car-choose.vue?vue&type=script&lang=js&"
export * from "./car-choose.vue?vue&type=script&lang=js&"
import style0 from "./car-choose.vue?vue&type=style&index=0&id=1c95712b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c95712b",
  null
  
)

export default component.exports